import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="w-full border-t border-slate-200 bg-white mt-auto pb-[env(safe-area-inset-bottom)]" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <p className="text-xs text-slate-400">&copy; {new Date().getFullYear()} Helm Core</p>
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/privacy')}
            className="text-xs text-slate-400 hover:text-navy transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
